import Vue from 'vue';

const notificationsBus = new Vue();

export default notificationsBus;

// eslint-disable-next-line no-shadow
export enum Event {
  DisplayBanner = 'DisplayBanner',
}

// eslint-disable-next-line no-shadow
export enum Type {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}

export interface Notification {
  type: Type;
  message?: string;
}

const displayBanner = (notification: Notification): void => {
  notificationsBus.$emit(Event.DisplayBanner, notification);
};

/**
 * Display a warning notification via a banner.
 *
 * @param message - Message to display.
 */
export const displayWarningBanner = (message: string): void => {
  const notification: Notification = {
    type: Type.Warning,
    message,
  };

  displayBanner(notification);
};

/**
 * Display a error notification via a banner.
 *
 * @param message - Message to display.
 */
export const displayErrorBanner = (message: string): void => {
  const notification: Notification = {
    type: Type.Error,
    message,
  };

  displayBanner(notification);
};

/**
 * Display a success notification via a banner.
 *
 * @param message - Message to display.
 */
export const displaySuccessBanner = (message: string): void => {
  const notification: Notification = {
    type: Type.Success,
    message,
  };

  displayBanner(notification);
};

/**
 * Display a info notification via a banner.
 *
 * @param message - Message to display.
 */
export const displayInfoBanner = (message: string): void => {
  const notification: Notification = {
    type: Type.Info,
    message,
  };

  displayBanner(notification);
};
